var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lp-bottom-sheet"},[_c('div',{staticClass:"lp-sheet__main"},[_vm._t("default")],2),_vm._v(" "),_vm._t("sheet")],2)}
var staticRenderFns = []

export { render, staticRenderFns }